import React, { useRef, useState } from "react";

import styles from "./Chooser.module.scss";
import { SettingsIcon } from "./assets";

import { ColumnChooserModal } from "src/components/IllioTable/ColumnChooserModal";
import { usePositionsWidget } from "../../extractedComponents/PositionsAndTransactions/PositionsWidget/hooks/usePositionsWidget";
import { observer } from "mobx-react-lite";
import { useTransactionsWidget } from "../../extractedComponents/PositionsAndTransactions/TransactionsWidget/hooks/useTransactionsWidget";
interface IProps {
  cellId: string;
  pageId: string;
}

export const TransactionChoooser: React.FC<any> = observer((props) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const { columnSettings, setColumnSettings, allColumns } =
    useTransactionsWidget(props.cellId, props.pageId);

  return (
    <div style={{ position: "relative" }}>
      <div onClick={handleClick} className={styles.button}>
        <SettingsIcon />
      </div>
      <ColumnChooserModal
        columns={allColumns}
        columnSettings={columnSettings}
        setColumnSettings={setColumnSettings}
        visible={isOpen}
        setVisible={setIsOpen}
      />
    </div>
  );
});
